/** @format */

import React from 'react';
import { Grid } from '@mui/material';
import {
  SelectV,
  InputV,
  ServiceSetComponent,
  ClientIdCombo,
  AutocompleteV,
  BusinessList,
} from 'components';
import { useFormContext } from 'react-hook-form';
import { BUSINESS_EXCEPTIONS_SSO_ID } from 'config';
import { useBusiness } from 'hooks';

const GeneralInfo = (props) => {
  const { selected, selectChange, classes } = props;
  const methods = useFormContext();
  const myBusiness = useBusiness();

  const paramsServiceSet = {
    pagination: { offset: 0, size: 15 },
  };

  const { scType, scAutoApprove } = methods.watch();

  return (
    <Grid container direction="row" alignItems="center" spacing={2}>
      <Grid item xs={12} container>
        <Grid item container spacing={2}>
          <Grid item xs={6} container spacing={2} direction="row">
            <Grid item xs={12}>
              <InputV
                fullWidth
                errors={methods.formState.errors}
                name="scFaName"
                register={methods.register}
                rules={['required', 'isAlphaFa']}
                control={methods.control}
              />
            </Grid>

            <Grid item xs={12}>
              <InputV
                fullWidth
                errors={methods.formState.errors}
                name="scEnName"
                register={methods.register}
                rules={['required', 'isAlphaEn']}
                control={methods.control}
              />
            </Grid>

            <Grid item xs={12}>
              <InputV
                fullWidth
                errors={methods.formState.errors}
                name="scProvider"
                register={methods.register}
                rules={['required']}
                control={methods.control}
              />
            </Grid>
          </Grid>

          <Grid item xs={6} container spacing={2}>
            <Grid item xs={12}>
              <InputV
                multiline
                fullWidth
                rows={9}
                errors={methods.formState.errors}
                name="description"
                register={methods.register}
                rules={['required']}
                control={methods.control}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={4}>
        <InputV
          fullWidth
          errors={methods.formState.errors}
          name="scUrl"
          register={methods.register}
          rules={['required', 'isURL']}
          control={methods.control}
        />
      </Grid>

      <Grid item xs={4}>
        <InputV
          fullWidth
          errors={methods.formState.errors}
          name="scHttpStatusCode"
          register={methods.register}
          rules={['required', 'isNumeric']}
          control={methods.control}
        />
      </Grid>

      <Grid item xs={4}>
        <InputV
          fullWidth
          errors={methods.formState.errors}
          name="scHttpResponse"
          register={methods.register}
          rules={['required']}
          control={methods.control}
        />
      </Grid>

      <Grid item xs={4}>
        <InputV
          fullWidth
          errors={methods.formState.errors}
          name="currentVersion"
          register={methods.register}
          rules={['required']}
          control={methods.control}
        />
      </Grid>

      <Grid item xs={4}>
        <SelectV
          name="scAutoApprove"
          options={[
            { value: 'false', label: 'نیاز به دسترسی' },
            { value: 'true', label: 'دسترسی آزاد' },
          ]}
          control={methods.control}
          rules={['required']}
          className={classes.formControl}
          errors={methods.formState.errors}
          fullWidth
          onChangeFunc={selectChange}
        />
      </Grid>

      <Grid item xs={4}>
        {scAutoApprove === 'true' && <ClientIdCombo methods={methods} setValueIndex="0" />}
      </Grid>

      <Grid item xs={2}>
        <SelectV
          name="scType"
          options={[
            { value: 'REST', label: 'REST' },
            { value: 'SOAP', label: 'SOAP' },
          ]}
          control={methods.control}
          rules={['required']}
          className={classes.formControl}
          errors={methods.formState.errors}
          fullWidth
          onChangeFunc={selectChange}
        />
      </Grid>
      {!scType && (
        <Grid item xs={6}>
          &nbsp;
        </Grid>
      )}

      {scType && scType === 'REST' && (
        <Grid item xs={6}>
          <SelectV
            name="scHttpVerb"
            options={[
              { value: 'DELETE', label: 'Delete' },
              { value: 'GET', label: 'Get' },
              { value: 'POST', label: 'Post' },
              { value: 'PUT', label: 'Put' },
              { value: 'OPTION', label: 'Option' },
            ]}
            control={methods.control}
            rules={['required']}
            className={classes.formControl}
            errors={methods.formState.errors}
            fullWidth
          />
        </Grid>
      )}

      {selected.scType && selected.scType === 'SOAP' && (
        <>
          <Grid item xs={3}>
            <InputV
              fullWidth
              errors={methods.formState.errors}
              name="scNamespace"
              register={methods.register}
              rules={['required']}
              control={methods.control}
            />
          </Grid>

          <Grid item xs={3}>
            <InputV
              fullWidth
              errors={methods.formState.errors}
              name="scMethodName"
              register={methods.register}
              rules={['required']}
              control={methods.control}
            />
          </Grid>
        </>
      )}

      <Grid item xs={4}>
        <AutocompleteV
          control={methods.control}
          errors={methods.formState.errors}
          register={methods.register}
          name="contentType"
          label="Content Type"
          rules={['required']}
          list={[
            {
              value: 'application/x-www-form-urlencoded',
              label: 'application/x-www-form-urlencoded',
            },
            { value: 'application/json', label: 'application/json' },
            { value: 'application/xsl', label: 'application/xsl' },
            { value: 'application/xml', label: 'application/xml' },
          ]}
          defaultValue="application/x-www-form-urlencoded"
        />
      </Grid>

      <Grid item xs={6}>
        <ServiceSetComponent
          errors={methods.formState.errors}
          control={methods.control}
          params={paramsServiceSet}
          required={false}
        />
      </Grid>

      {BUSINESS_EXCEPTIONS_SSO_ID.indexOf(myBusiness.ssoId) > -1 && (
        <Grid item xs={6}>
          <BusinessList
            label="ارائه دهنده سرویس"
            name="providerBusinessId"
            errors={methods.formState.errors}
            control={methods.control}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default GeneralInfo;
